import { Context } from '@/context/appContext';
import { AppStateActions } from '@/reducers/appReducer';
import { Box, Divider, Link, useTheme } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { EmailForm } from './EmailForm';
import { GoogleButton } from './GoogleButton';
import { LegalInfo } from './LegalInfo';
import { Header } from './styles';

export function AuthView() {
  const { t } = useTranslation('web', { keyPrefix: 'components.AuthModal' });
  const theme = useTheme();
  const {
    state: { authState },
    dispatch,
  } = useContext(Context);

  const handleToggleState = () =>
    dispatch({
      type: AppStateActions.SET_AUTH_STATE,
      payload: { state: authState.state === 'SIGN_IN' ? 'SIGN_UP' : 'SIGN_IN', force: authState.force },
    });

  return (
    <Box gap={4} display={'flex'} flexDirection={'column'} padding={8} width={{ xs: '100%', md: theme.spacing(110) }}>
      <Header>
        {authState.force
          ? authState.state === 'SIGN_IN'
            ? t('forceSignIn')
            : t('forceSignUp')
          : authState.state === 'SIGN_IN'
          ? t('signInHeader')
          : t('signUpHeader')}
      </Header>

      <GoogleButton />
      <Divider sx={{ color: 'text.secondary' }}>{t('or')}</Divider>
      <EmailForm />
      <LegalInfo />

      <Box display={'flex'} gap={3} justifyContent={'center'} fontWeight={600} fontSize={14}>
        <span>{authState.state === 'SIGN_IN' ? t('noAccount') : t('haveAccount')}</span>
        <Link underline="none">
          <button
            onClick={handleToggleState}
            style={{
              background: 'transparent',
              border: 'none',
              padding: 0,
              color: 'inherit',
              font: 'inherit',
              cursor: 'inherit',
            }}
          >
            {authState.state === 'SIGN_IN' ? t('signUp') : t('signIn')}
          </button>
        </Link>
      </Box>
    </Box>
  );
}
